import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Rating } from '@fiverr-private/orca';
import { getContext } from '@fiverr-private/fiverr_context';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { getProfileUrl } from '../../../../utils/getSellerUrl/getProfileUrl';
import RatingWrapper from '../../../shared/RatingWrapper';
import { SellerLevelBadge } from '../../../shared/SellerLevelBadge';
import { mobileRatingFont } from './RatingLine.ve.css';

const SELLER_REVIEWS_ANCHOR = 'Reviews';
const AGENCY_REVIEWS_ANCHOR = 'reviews_tab';

interface RatingLineProps {
  rating: number;
  ratingsCount: number;
}

export const RatingLine: React.FC<RatingLineProps> = ({ rating, ratingsCount }) => {
  const { isInCheetahsMobileGigPage } = useGigPageContext();
  const themeOverride = useRatingTheme(isInCheetahsMobileGigPage);
  const onRatingClick = useReviewsRedirect();

  return (
    <Stack gap="3" alignItems="center" width="fit-content">
      <RatingWrapper
        className={isInCheetahsMobileGigPage ? mobileRatingFont : undefined}
        rating={rating}
        ratingsCount={ratingsCount}
        themeOverride={themeOverride}
        onClick={onRatingClick}
      />
      <SellerLevelBadge withSeparator />
    </Stack>
  );
};

const useReviewsRedirect = () => {
  const {
    pathfinderWrapper,
    seller: { isAgency, agency },
  } = useGigPageContext();

  return () => {
    const profileUrl = getProfileUrl({ pathfinderWrapper, isAgency, agency });
    const anchor = isAgency && agency?.slug ? AGENCY_REVIEWS_ANCHOR : SELLER_REVIEWS_ANCHOR;
    window.open(`${profileUrl}#${anchor}`, '_blank', 'noopener,noreferrer');
  };
};

const useRatingTheme = (isInCheetahsMobileGigPage: boolean) => {
  const { userId } = getContext();
  if (isInCheetahsMobileGigPage || !userId) {
    return undefined;
  }
  // @ts-expect-error No TS definitions come from Orca.Rating component
  return Rating.THEMES.FIVE_STARS;
};
